import siteData from '../data/siteData';
import { scrapeImages } from './scrapeImages';

async function doFetch(url) {
  // /api/generate（Anthropic + Unsplash）と scrapeImages を並列実行
  const [apiResult, scrapeResult] = await Promise.all([
    fetch('/api/generate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url }),
    }).then(r => {
      if (!r.ok) throw new Error(`バックエンドエラー: ${r.status}`);
      return r.json();
    }),
    scrapeImages(url).catch(() => ({ heroImage: null, images: [] })),
  ]);

  // scrapeImages の結果を優先、不足分は Unsplash（バックエンドから）で補完
  const heroImage = scrapeResult.heroImage || apiResult.heroImage;
  let images = scrapeResult.images;

  if (images.length < 2) {
    const needed = 3 - images.length;
    images = [...images, ...(apiResult.images ?? []).slice(0, needed)];
  }

  return {
    ...siteData,
    ...apiResult,
    heroImage: heroImage ?? siteData.heroImage,
    images: images.length > 0 ? images : siteData.images,
  };
}

export async function fetchSiteData(url) {
  // 60秒でタイムアウト → ダミーデータにフォールバック
  const timeout = new Promise((resolve) =>
    setTimeout(() => {
      console.error('fetchSiteData: タイムアウト発生（60秒）');
      resolve(siteData);
    }, 60000)
  );

  try {
    return await Promise.race([doFetch(url), timeout]);
  } catch (err) {
    console.error('fetchSiteData APIエラー:', err.message ?? err);
    throw err;
  }
}
